const loadIot = () => {
  const iotSystemsNode = document.querySelector('.iot-system-at-a-glance');
  const iotFeatureNodes = document.querySelectorAll('.iot-features--grid');

  if (iotSystemsNode) {
    const options = {
      threshold: .3,
      rootMargin: '0px 0px 0px 0px'
    };

    const initIotAnimation = new IntersectionObserver((entries, animation) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          animation.unobserve(entry.target);
        }
      });
    }, options);

    initIotAnimation.observe(iotSystemsNode);
  }

  if (iotFeatureNodes) {
    const options = {
      threshold: .75,
      rootMargin: '0px 0px 0px 0px'
    };

    const initIotFeaturesObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          entry.target.classList.add('active');
          observer.unobserve(entry.target);
        }
      });
    }, options);

    iotFeatureNodes.forEach(iotFeatureNode => {
      initIotFeaturesObserver.observe(iotFeatureNode);
    });
  }
};

export default loadIot;
